import { Row, Col, Button } from "rsuite";
import { Container } from "react-bootstrap";
import { AirplaneFill, CaretDownFill, CarFrontFill, Pen, GeoAltFill, CheckCircleFill } from "react-bootstrap-icons";
import { useOrderCreation } from "../context/OrderCreationContext";
import { OrderType, OrderStatus, SourceChannel } from "../../../../../my-enum";
import { authUserData } from "../../../../../service";
import { createOrder } from "../../../../../service/OrderService";
import { SPECIAL_REQUESTS } from "../../../../../my-type";
import type { Order } from "../../../../../my-type";
import { useToaster, Message } from "rsuite";
import React from "react";

const messageErrorPush = (strMessage: string) => (
  <Message showIcon type="error" closable>
    {strMessage}
  </Message>
);

export const OrderConfirmation: React.FC = () => {
  const {
    orderType,
    rideTime,
    selectedAdress,
    selectedTerminal,
    estArriveTime,
    flightSchedule,
    flightTime,
    isRidetimeTooLateOrEarly,
    isRideTimeValid,
    passengerName,
    passengerPhone,
    passengerEmail,
    passengerID,
    displayRegistedLuggage,
    luggageNote,
    adultCount,
    babyCount,
    userVehicle,
    getTotalFee,
    isShowWarning,
    setIsShowWarning,
    setStep,
    setIsShowLoading,
    setNewCreatedOrderID,
    viaPoints,
    specialRequests,
    meetAndGreetDetails,
    flightNo
  } = useOrderCreation();

  const authUser = authUserData();
  const toaster = useToaster();

  const onCreateOrder = async () => {
    // Build viaPoints array from non-empty via points
    const validViaPoints: string[] = [];
    if (viaPoints && viaPoints.length > 0) {
      viaPoints.forEach(point => {
        if (point && point.trim() !== '') {
          validViaPoints.push(point.trim());
        }
      });
    }

    let newOrder: Order = {
      id: 0,
      orderID: "x",
      userID: authUser!.userId,
      userUID: authUser!.id,
      orderType: orderType,
      address: selectedAdress!,
      terminal: selectedTerminal!.name,
      rideTime: rideTime,
      estArriveTime: estArriveTime!,
      flightNo: flightNo,
      flightTime: flightTime ? flightTime! : null,
      rideTimeValid: isRideTimeValid,
      vehicleID: userVehicle!.vehicleID,
      luggages: displayRegistedLuggage(false).toString(),
      luggageNote: luggageNote!,
      passengerName: passengerName!,
      passengerPhone: passengerPhone!,
      passengerID: passengerID!,
      passengerAdult: adultCount,
      passengerBaby: babyCount,
      driverUID: 0,
      driver: null,
      rideFee: getTotalFee(),
      status: OrderStatus.派車中,
      createdAt: new Date(),
      completedAt: null,
      teamCode: authUser!.team.code,
      signatureFileName: null,
      rentalStartTime: null,
      rentalEndTime: null,
      paymentPaid: false,
      email: passengerEmail ? passengerEmail : '',
      isAdminOrder: false,
      fromUserUID: null,
      driverCommission: null,
      viaPoints: validViaPoints.length > 0 ? validViaPoints : null,
      specialRequests: specialRequests.length > 0 ? specialRequests : null,
      meetAndGreetDetails: meetAndGreetDetails && meetAndGreetDetails.trim() !== '' ? meetAndGreetDetails.trim() : null,
      supplierId: 1,
      sourceChannel: SourceChannel.官LINE,
      externalBookingNo: null,
      // TODO: Add chat app fields for rider order creation if needed
      chatApp: null,
      chatId: null,
      assignedCarModel: null,
      isBlindOrder: false,
      destinationAddress: null
    };

    setIsShowLoading(true);

    let uploadedOrder = await createOrder(newOrder);

    if (uploadedOrder) {
      setNewCreatedOrderID(uploadedOrder.orderID);
      setStep(9);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      toaster.push(messageErrorPush("新增訂單時發生錯誤"), { placement: 'topCenter', duration: 2000 });
    }

    setIsShowLoading(false);
  };

  return (
    <Container fluid="md" style={{ backgroundColor: 'white' }} className="rounded">
      <br />
      <Row>
        <Col xs={17} style={{ textAlign: 'left' }}>
          <h5>旅客資訊</h5>
          {isShowWarning && <span style={{ color: 'red', fontSize: '11px' }}>未填寫</span>}
        </Col>
        <Col xs={7} style={{ textAlign: 'right' }}>
          {passengerName && <Button appearance="link" onClick={() => setStep(6)}>編輯</Button>}
        </Col>
      </Row>
      <br />

      <Row>
        <Col xs={12} style={{ textAlign: 'left' }}>姓名</Col>
        <Col xs={7} style={{ textAlign: 'left', color: 'GrayText' }}>
          {passengerName ? passengerName : '未填寫'}
        </Col>
      </Row>

      <Row style={{ paddingTop: '10px' }}>
        <Col xs={12} style={{ textAlign: 'left' }}>電話</Col>
        <Col xs={7} style={{ textAlign: 'left', color: 'GrayText' }}>
          {passengerPhone ? passengerPhone : '未填寫'}
        </Col>
      </Row>

      <Row style={{ paddingTop: '10px' }}>
        <Col xs={12} style={{ textAlign: 'left' }}>Email</Col>
        <Col xs={7} style={{ textAlign: 'left', color: 'GrayText' }}>
          {passengerEmail ? passengerEmail : '未填寫'}
        </Col>
      </Row>
      <br />
      <br />

      {!passengerName && (
        <>
          <Row>
            <Col xs={24}>
              <div className="d-grid gap-2">
                <Button appearance="default" size="sm" onClick={() => setStep(6)}>
                  新增資料
                </Button>
              </div>
            </Col>
          </Row>
          <br />
        </>
      )}

      <br />
      <br />
      <Row>
        <Col style={{ textAlign: 'left' }}>
          <h5>您的{orderType === OrderType.送機 ? '送機' : '接機'}計劃</h5>
        </Col>
      </Row>
      <br />

      <Row>
        <Col xs={2}><CarFrontFill /></Col>
        <Col style={{ textAlign: 'left' }}>
          {rideTime?.toLocaleString().substring(0, rideTime?.toLocaleString().length - 3)} 乘車時間
          {isRidetimeTooLateOrEarly && (
            <>
              <br />
              <span style={{ color: 'red', fontSize: '12px' }}>搭乘時間不符合建議時間</span>
            </>
          )}
          <br />
          <span style={{ color: 'GrayText', fontSize: '12px' }}>
            {orderType === OrderType.送機 ? selectedAdress : selectedTerminal?.name}
          </span>
        </Col>
        {isRidetimeTooLateOrEarly && <Col xs={2}><Pen onClick={() => setStep(0)} /></Col>}
      </Row>
      <br />

      {/* Display Via Points if available */}
      {viaPoints && viaPoints.length > 0 && viaPoints.some(point => point.trim() !== '') && (
        <>
          {viaPoints.map((viaPoint, index) => (
            viaPoint.trim() !== '' && (
              <React.Fragment key={index}>
                <Row>
                  <Col xs={2}><GeoAltFill /></Col>
                  <Col style={{ textAlign: 'left' }}>
                    經由地點 {index + 1}
                    <br />
                    <span style={{ color: 'GrayText', fontSize: '12px' }}>
                      {viaPoint}
                    </span>
                  </Col>
                  <Col xs={2} />
                </Row>
                <br />
              </React.Fragment>
            )
          ))}
        </>
      )}

      <Row>
        <Col xs={2}><CaretDownFill /></Col>
        <Col style={{ textAlign: 'left' }}>
          {estArriveTime?.toLocaleString().substring(0, estArriveTime?.toLocaleString().length - 3)} 下車時間(預估)
          <br />
          <span style={{ color: 'GrayText', fontSize: '12px' }}>
            {orderType === OrderType.送機 ? selectedTerminal?.name : selectedAdress}
          </span>
        </Col>
        <Col xs={2} />
      </Row>
      <br />

      {flightSchedule && (
        <Row>
          <Col xs={1}><AirplaneFill /></Col>
          <Col style={{ textAlign: 'left' }}>
            {flightTime?.toLocaleString().substring(0, flightTime?.toLocaleString().length - 3)}
            &nbsp;
            {orderType === OrderType.送機 ? '起飛' : '抵達'}
            <br />
            <span style={{ color: 'GrayText', fontSize: '12px' }}>{flightSchedule?.FlightNumber}</span>
          </Col>
          <Col xs={2} />
        </Row>
      )}
      <br />
      <br />
      <br />

      {specialRequests && specialRequests.length > 0 && (
        <>
          <Row>
            <Col style={{ textAlign: 'left' }}>
              <h5>特殊需求</h5>
            </Col>
          </Row>
          <br />

          <Row>
            <Col xs={2}><CheckCircleFill /></Col>
            <Col style={{ textAlign: 'left' }}>
              {specialRequests.map((requestValue, index) => {
                const request = SPECIAL_REQUESTS.find(r => r.value === requestValue);
                return request ? (
                  <div key={index} style={{ color: 'GrayText', fontSize: '14px' }}>
                    • {request.label}
                  </div>
                ) : null;
              })}
            </Col>
            <Col xs={2}><Pen onClick={() => setStep(3)} /></Col>
          </Row>
          <br />
          <br />
          <br />
        </>
      )}

      {/* TODO: Rename luggageNote to rideNote */}
      {luggageNote && luggageNote.trim() !== '' && (
        <>
          <Row>
            <Col style={{ textAlign: 'left' }}>
              <h5>乘車備註</h5>
            </Col>
          </Row>
          <br />

          <Row>
            <Col xs={2}></Col>
            <Col style={{ textAlign: 'left' }}>
              <div style={{ color: 'GrayText', fontSize: '14px', whiteSpace: 'pre-wrap' }}>
                {luggageNote}
              </div>
            </Col>
            <Col xs={2}><Pen onClick={() => setStep(3)} /></Col>
          </Row>
          <br />
          <br />
          <br />
        </>
      )}

      <Row>
        <Col xs={24} style={{ textAlign: 'right', marginBottom: '15px' }}>
          <Button
            appearance="primary"
            color="yellow"
            onClick={() => {
              if (passengerName && passengerPhone) {
                onCreateOrder();
              } else {
                setIsShowWarning(true);
              }
            }}
          >
            確認訂單
          </Button>
        </Col>
      </Row>

      <p style={{ fontSize: '12px', textAlign: 'left' }}>退款說明</p>
      <p style={{ fontSize: '12px', textAlign: 'left' }}>
        1. 依照交通部觀光局規定，旅客於搭乘前24小時內取消訂單，將不予退費。<br />
        2. 旅客於搭乘前24小時以上取消訂單，將全額退費。<br />
        3. 退款金額將於7-14個工作天內退回原付款帳戶。
      </p>
      <br />
    </Container>
  );
};
